import React from "react";
import Row from "./common/Row";
import Field from "./common/Field";
import { StyleSheet, Text } from "@react-pdf/renderer";
import { config } from "./common/config";

const styles = StyleSheet.create({
  subtext: {
    color: config.grayColor,
    fontSize: config.normalFontSize + 1,
    marginBottom: 5,
  },

  subtitle: {
    width: "100%",
    borderBottomWidth: 2,
    borderBottomColor: "#118052",
    paddingBottom: 2,
    marginBottom: 4,
  },
  bottomBorder: {
    // borderBottomColor: config.grayColor,
    // borderBottomWidth: 1,
    marginBottom: 10,
    paddingTop: 5,
  },
});

const getAccTasks = (tasks, userId) => {
  return tasks.filter((task) => task.acc?.userId === userId);
};

const getDoneAccTasks = (tasks, userId) => {
  return tasks.filter(
    (task) => task.acc?.userId === userId && task.status === "done",
  );
};

const Users = ({ relatory }) => {
  const users = relatory.relatedUsers;

  return users.map((user, index) => (
    <React.Fragment key={Math.random()}>
      <Row style={styles.bottomBorder}>
        <Field label={`Nome`}>
          <Text style={styles.subtext}>{user.username}</Text>
        </Field>
        <Field label={`email`}>
          <Text style={styles.subtext}>{user.email}</Text>
        </Field>
        <Field label={`Nº de Tarefas`}>
          <Text style={styles.subtext}>
            {getAccTasks(relatory.tasks, user._id).length.toString()}
          </Text>
        </Field>
        <Field label={`Tarefas Concluídas`}>
          <Text style={styles.subtext}>
            {getDoneAccTasks(relatory.tasks, user._id).length.toString()}
          </Text>
        </Field>
      </Row>
    </React.Fragment>
  ));
};
export default Users;
